export default class CreationDeCompteModel {

  id = new Date().valueOf();
  prenom;
  nom;
  sexe;
  typeDeCoordonnees;
  organisation;
  courriel;
  telephone;
  cellulaire;
  posteTelephonique;
  adresse;
  complementAdresse;
  ville;
  codePostal;
  province = "nSiZdM3R1EpL3IQcn7Nevs9fQGQR1EpL1R1EpL1";
  pays = "QR1EpL3FU6VRDYAQMz1v4cfCd5wR1EpL1R1EpL1";
  photo;

}